import { isVeryNarrow } from 'util/screenUtils'
import { Grid, useMediaQuery } from '@material-ui/core'


import HomeCard from 'components/HomeCard'
import artist from '../../images/artist.jpg'
import listener from '../../images/listener.jpg'
import musicStudio from '../../images/studio.jpg'
import uploadSong from '../../images/upload.jpg'
import { getStorageAccount } from 'redux/actions/accountActions'
import { useHistory } from 'react-router-dom'

export default function IntroductionGrid({ setShowSignIn }) {
    const veryNarrow = isVeryNarrow(useMediaQuery)
    const gridStyles = {
        item: {
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: veryNarrow ? '0.75em' : '1em', lineHeight: 'normal'
        },
    }
    const account = getStorageAccount()
    const history = useHistory()
    const artistTile = (ix) => {
        return (
            <Grid key={ix} item xs style={gridStyles.item}>
                <HomeCard title='Better Payments' image={artist} link='/About'
                    messageId='66f8544ef81fa131e2b24f3a'

                />
            </Grid>
        )
    }

    const listenerTile = (ix) => {
        return (
            <Grid key={ix} item xs style={gridStyles.item}>
                <HomeCard link='/Pricing' image={listener} title='Lower Costs' messageId='66f96c5ff81fa131e2b251b6' />
            </Grid>
        )
    }

    const spotifyTile = (ix) => {
        return (
            <Grid key={ix} item xs style={gridStyles.item}>
                <HomeCard link='/Pricing' title='Compare To Spotify' messageId='66ffec25f81fa131e2b25ea0' />
            </Grid>
        )
    }
    const studioTile = (ix) => {
        return (
            <Grid key={ix} item xs style={gridStyles.item}>
                <HomeCard link='/help/AboutStudios' image={musicStudio} title='Better Social' messageId='66f96922f81fa131e2b25161' />
            </Grid>
        )
    }

    const uploadSongTile = (ix) => {
        return (
            <Grid key={ix} item xs style={gridStyles.item}>
                <HomeCard link='/help/AboutStudios' image={uploadSong} title='Upload Your Song'
                    description={`Upload your own song and take advantage of everything Harmonize offers you. It's free to join and upload! Just
                    be sure you own all the rights to the song.`}
                    action={() => account ? history.push(`/@${account.handle}/private/true`) : setShowSignIn(true)} />
            </Grid>
        )
    }

    const rearrange = () => {

        const rearrangedTiles = []
        //getFeaturedCollectionCard(1, rearrangedTiles)
        rearrangedTiles.push(artistTile(10))
        rearrangedTiles.push(studioTile(11))
        rearrangedTiles.push(uploadSongTile(100))
        rearrangedTiles.push(spotifyTile(50))
        rearrangedTiles.push(listenerTile(12))
        //rearrangedTiles.push(demoTile(13))
        //rearrangedTiles.push(aiTile(14))

        //let updatedSongs = getPublicSongCardPlayer(songs, 'Righteous Society', rearrangedTiles, 0)
        //updatedSongs = getPublicSongCardPlayer(updatedSongs, 'Hang Your Feet out the Window', rearrangedTiles, 1)

        return (
            <Grid container spacing={veryNarrow ? 2 : 3} style={{ width: '100%', paddingTop: '1em', margin: 0 }}  >
                {rearrangedTiles.map(m => m)}

            </Grid>
        )

    }

    const displayMain = () => {
        return (
            <div style={{ width: '100%' }}>
                {rearrange()}
            </div>
        )
    }

    return displayMain()
}